/**
 * Columnas para exportación de contactos.
 * Usadas en ContactsExportDrawer.
 */

export const CONTACTS_EXPORT_COLUMN_IDS = [
    { id: 'id', labelKey: 'id', active: true },
    { id: 'type', labelKey: 'type', active: true },
    { id: 'subtype', labelKey: 'subtype', active: true },
    { id: 'name', labelKey: 'name', active: true },
    { id: 'note', labelKey: 'internal-note', active: true },
    { id: 'tax_id', labelKey: 'tax-id', active: true },
    { id: 'tax_id_type', labelKey: 'tax-id-type', active: true },
    { id: 'email', labelKey: 'email', active: true },
    { id: 'phone_number', labelKey: 'phone-number', active: true },
    { id: 'website', labelKey: 'website', active: true },
    { id: 'address', labelKey: 'address', active: true, group: 'address' },
    { id: 'postal_code', labelKey: 'postal-code', active: true, group: 'address' },
    { id: 'city', labelKey: 'city', active: true, group: 'address' },
    { id: 'state', labelKey: 'state', active: true, group: 'address' },
    { id: 'country', labelKey: 'country', active: true, group: 'address' },
    { id: 'language', labelKey: 'language', active: true },
    { id: 'currency', labelKey: 'currency', active: true },
    { id: 'due_days', labelKey: 'due-days', active: true },
    { id: 'payment_day', labelKey: 'payment-day', active: true },
    { id: 'taxonomies_tags', labelKey: 'tags', active: true },
    { id: 'categorization_keywords', labelKey: 'categorization-keywords', active: true },
    { id: 'taxes_incomes', labelKey: 'taxes-incomes', active: true },
    { id: 'taxes_expenses', labelKey: 'taxes-expenses', active: true },
    { id: 'creation_date', labelKey: 'creation-date', active: true },
];

/**
 * Genera las columnas de exportación de contactos con las traducciones aplicadas.
 * @param {function} t - Función de traducción de i18next
 * @returns {Array} Columnas con labels traducidos
 */
export function getContactsExportColumns(t) {
    return CONTACTS_EXPORT_COLUMN_IDS.map((col) => ({
        id: col.id,
        label: t(col.labelKey),
        active: col.active,
        ...(col.group ? { group: col.group } : {}),
    }));
}

/**
 * Grupos de columnas para el selector.
 */
export const CONTACTS_EXPORT_COLUMN_GROUPS_KEYS = [
    { id: 'address', labelKey: 'address-group' },
];

/**
 * Genera los grupos de columnas con las traducciones aplicadas.
 * @param {function} t - Función de traducción de i18next
 * @returns {Array} Grupos con labels traducidos
 */
export function getContactsExportColumnGroups(t) {
    return CONTACTS_EXPORT_COLUMN_GROUPS_KEYS.map((group) => ({
        id: group.id,
        label: t(group.labelKey),
    }));
}

/**
 * Columnas que no pueden ser desactivadas.
 */
export const CONTACTS_DISABLED_COLUMNS = [];
